import { render, staticRenderFns } from "./IncomesFromSale.vue?vue&type=template&id=6514944c&scoped=true"
import script from "./IncomesFromSale.vue?vue&type=script&lang=js"
export * from "./IncomesFromSale.vue?vue&type=script&lang=js"
import style0 from "./IncomesFromSale.vue?vue&type=style&index=0&id=6514944c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6514944c",
  null
  
)

export default component.exports